import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'antd'
import { TextBox } from '../../../EditProfile/Inputs'
import { Title } from '../../../EditProfile/Inputs/styles'
import { Text } from '../../../../constants/TextConstants'
import { useInputValue } from '../../../../hooks/useInputValue'
import { ButtonContainer } from '../../../Base/Forms/styles'

const RepositoryModal = ({
  open,
  setModal,
  setModelProfile,
  title,
  initialState
}) => {
  const linkedinLink = useInputValue('')
  const githubLink = useInputValue('')

  const onSubmit = () => {
    setModelProfile({
      ...initialState,
      repository: {
        linkedin_link: linkedinLink.value,
        github_link: githubLink.value
      }
    })
    setModal(false)
  }

  useEffect(() => {
    if (open) {
      linkedinLink.setValue(initialState.repository.linkedin_link)
      githubLink.setValue(initialState.repository.github_link)
    }
  }, [open])

  return (
    <Modal
      onOk={Text.add}
      title={title}
      open={open}
      footer={null}
      onCancel={() => setModal(false)}
      maskClosable={false}
      keyboard={false}>
      <Title style={{ width: 'fit-content' }}>{Text.LinkedInProfile}</Title>
      <TextBox
        placeholder={Text.LinkedInProfile}
        {...linkedinLink}
      />
      <Title style={{ width: 'fit-content', marginTop: '16px' }}>{Text.GitHubProfile}</Title>
      <TextBox
        placeholder={Text.GitHubProfile}
        {...githubLink}
      />

      <ButtonContainer>
        <Button onClick={() => setModal(false)} style={{ marginRight: '10px' }}>
          Cancel
        </Button>
        <Button type='primary' onClick={onSubmit} disabled={false}>
          Add
        </Button>
      </ButtonContainer>
    </Modal>
  )
}

RepositoryModal.propTypes = {
  open: PropTypes.bool,
  setModal: PropTypes.func,
  setModelProfile: PropTypes.func,
  title: PropTypes.string,
  initialState: PropTypes.object
}

export default RepositoryModal
